export const STAR_RATE_CONSTANTS = {
   ACCENT: 'accent',
   STAR: 'star',
   STAR_BORDER: 'star_border',
   STAR_COUNT: 5,
   RATING: 3
};
